// packages/agent-kit/src/public/investment/useAgentOffering.ts

import useSWR from 'swr';
import { investmentsService, isApiError } from '@dopomogai/api-client';
import type { InvestOfferingResponse } from '@dopomogai/types';
import { AgentKitError } from '../../types';

export const useAgentOffering = (agentId: string | null | undefined) => {
  const swrKey = agentId ? ['/invest/agents', agentId] as const : null;

  const { data, error, isLoading, mutate } = useSWR<InvestOfferingResponse, AgentKitError>(
    swrKey,
    async () => {
      if (!agentId) throw new AgentKitError('Missing agentId');
      const res = await investmentsService.getOffering(agentId);
      if (isApiError(res)) throw new AgentKitError('Failed to fetch agent offering', res);
      return res;
    },
    // --- ADD THIS ---
    {
      revalidateOnFocus: false,
    }
  );

  return {
    offering: data?.offering ?? null,
    stats: data?.stats,
    isLoading,
    error,
    mutate,
  };
};